export function addAccompanimentsListInCalled(accompaniments, calledId) {
  return {
      type: 'ACCOMPANIMENTS_ADD_ACTIONS_LIST_IN_CALLED',
      accompaniments,
      calledId
  }
}